import { useTranslation } from 'next-i18next';
import { Link } from '@hub/common/Link/Link';
import { IbhShape } from '@igus/iglidur-bearing-hub-api/src/data-contracts';
import { useRouter } from 'next/router';
import { EXTERNAL_LINKS } from '@hub/libs/redirect.helper';

interface NothingFoundProps {
  dimensionFormIsCompleted?: boolean;
  selectedShapeKey: IbhShape;
  mobile?: boolean;
}

export const NothingFound = ({ dimensionFormIsCompleted, selectedShapeKey, mobile = false }: NothingFoundProps) => {
  const { t } = useTranslation();
  const { locale } = useRouter();

  return (
    <div data-testid={`nothing-found${mobile ? '-mobile' : ''}`} className="">
      {dimensionFormIsCompleted ? (
        <span data-testid="nothing-found-text">
          {t(`PRODUCT_OVERVIEW.OVERVIEW_NO_MATCHES_TEXT`, { ns: 'category/categoryPage' })}
        </span>
      ) : (
        <span data-testid="nothing-found-text">
          {selectedShapeKey === IbhShape.EC
            ? t(`COMMON.CUSTOM_PRODUCT_NOT_FOUND_EC`, { ns: 'bearing-hub/bearingHub' })
            : t(`COMMON.CUSTOM_PRODUCT_NOT_FOUND`, { ns: 'bearing-hub/bearingHub' })}
        </span>
      )}

      <Link
        flex={false}
        text={t('PRODUCT_OVERVIEW.OVERVIEW_NO_MATCHES_LINK_DESCRIPTION', { ns: 'category/categoryPage' })}
        href={EXTERNAL_LINKS.INQUIRY_INDIVIDUAL_COMPONENT(locale)}
        primary
        external
      />
    </div>
  );
};
